/**
 * Hashes de teatros hardcodeados en el proyecto.
 *
 * Mantener centralizados acá para tener una única fuente de verdad
 * y evitar strings mágicos repetidos en los componentes.
 */
export const TEATRO_HASH_SAN_FERNANDO = 'f8FicByFbTUnVuFL1D6S';
